import { EmRouteConfig } from 'emrn-navigation';
import { EMAppProps } from 'emrn-navigation/EMAppPropsContext';
import { getMatchedRoute } from 'emrn-navigation/getMatchedRoute';

interface GetRoutesConfigOptions {
  appProps: EMAppProps;
  routes: EmRouteConfig[];
  defaultRouteName: string;
}

/**
 * 获取路由配置
 * @param options 配置
 */
export function getRoutesConfig(options: GetRoutesConfigOptions) {
  let initialRoute: EmRouteConfig | undefined;
  const { routes, appProps, defaultRouteName } = options;
  const { page, rootTag, ...restAppProps } = appProps;

  [page, defaultRouteName].forEach(routeName => {
    if (!initialRoute) {
      initialRoute = getMatchedRoute(routes, routeName);
    }
  });

  !initialRoute && (initialRoute = routes[0]);

  if (restAppProps) {
    initialRoute.params = initialRoute.params || {};
    Object.assign(initialRoute.params, restAppProps);
  }

  return { routes, initialRouteName: initialRoute.routeName };
}
